import { Component } from 'react';

class SignTimer extends Component {
  componentDidMount() {
    this.props.requestSign(this.props.signId);
  }

  componentWillUnmount() {
    this.props.stopAnimations();
  }

  render() {
    return null;
  }
}

export default SignTimer;



// WEBPACK FOOTER //
// ./src/components/SignTimer/index.js